// Kopf der Seite: schwarz, in zwei Zeilen (Wortmarke + Sprache + Setup, darunter die Hauptnavigation),
// Aufbau wie genelec.com. Am Handy nur die erste Zeile mit dem Seitennamen; die Reiter stehen dann unten
// (phonenav.ts, phone.css).
import { h, type VNode } from 'snabbdom';
import { getLang, LANGS, setLang, t } from '../i18n';
import { isPublic } from '../util';

/** Am Handy scrollt die Reiterleiste: den aktiven Reiter nach einem Seitenwechsel in die Mitte holen. */
let shownTab = '';
function showActiveTab(el: HTMLElement) {
  const a = el.querySelector<HTMLElement>('.tab.active');
  const key = a?.getAttribute('href') ?? '';
  if (!a || key === shownTab) return;
  shownTab = key;
  if (el.scrollWidth > el.clientWidth) el.scrollTo({ left: a.offsetLeft - el.offsetLeft - (el.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' });
}

/** `active`: Name der Route; `where`: Seitenname, am Handy rechts in der Kopfzeile statt Reitern und Titelband */
export function topNav(active: string, analyseHref: string, where: string, redraw: () => void): VNode {
  const tab = (href: string, label: string, on: boolean) =>
    h('a.tab', { class: { active: on }, attrs: { href, 'aria-current': on ? 'page' : false } }, t(label));
  return h('header.top', [
    h('div.bar', [
      h('a.wordmark', { attrs: { href: '#/spielen' } }, 'SCHACHSERVER'),
      h('span.where', where),
      h('div.util', [
        h('div.langs', { attrs: { role: 'group', 'aria-label': t('Sprache') } }, LANGS.map(l =>
          h('button.lang', { class: { active: getLang() === l }, attrs: { 'aria-pressed': String(getLang() === l) }, on: { click: () => (setLang(l), redraw()) } }, l.toUpperCase()))),
        h('a.pill', { class: { active: active === 'setup' }, attrs: { href: '#/setup' } }, t('Setup')),
      ]),
    ]),
    h('nav.bar', { hook: { insert: v => showActiveTab(v.elm as HTMLElement), postpatch: (_, v) => showActiveTab(v.elm as HTMLElement) } }, [
      tab('#/bibliothek', 'Bibliothek', active === 'library'),
      tab(analyseHref, 'Analyse', active === 'game' || active === 'analyse'),
      tab('#/spielen', 'Spielen', active === 'play'),
      tab('#/taktik', 'Taktik', active === 'puzzle'),
      tab('#/foto', 'Foto', active === 'photo'),
      tab('#/editor', 'Brett-Editor', active === 'editor'),
      isPublic ? null : tab('#/wallpaper', 'Wallpaper', active === 'wallpaper'),
    ]),
  ]);
}
